import { css } from 'styled-components';

export const setSvgColor = (color: string) => {
  return css`
    svg {
      path {
        fill: ${color};
      }
    }
  `;
};

export const flexCenter = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const paddingWithScrollBar = (padding: string) => css`
  ${({ theme }) => `calc(${padding} - ${theme.scrollBarWidth})`}
`;

export const maxLines = (lines: number) => css`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${lines};
  line-clamp: ${lines};
  -webkit-box-orient: vertical;
`;

export const absoluteFill = css`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
`;
